import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import CheckoutAddress from "./pages/CheckoutAddress";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminOrders from "./pages/AdminOrders";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <CartProvider>
                    <Header />
                    <CartDrawer />
                    <main data-testid="site-main">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/shop" element={<Shop />} />
                            <Route
                                path="/product/:id"
                                element={<ProductDetail />}
                            />
                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route
                                path="/checkout"
                                element={<CheckoutAddress />}
                            />
                            <Route
                                path="/checkout/success"
                                element={<CheckoutSuccess />}
                            />
                            <Route path="/admin" element={<AdminLogin />} />
                            <Route
                                path="/admin/orders"
                                element={<AdminOrders />}
                            />
                        </Routes>
                    </main>
                    <Footer />
                    <Toaster
                        position="top-right"
                        toastOptions={{
                            style: {
                                background: "#0A2342",
                                color: "#FBF9F6",
                                border: "1px solid #103768",
                                borderRadius: "2px",
                                fontFamily: "DM Sans, sans-serif",
                            },
                        }}
                    />
                </CartProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
